<template>
  <div class="sidebar">
    <div class="sidebar-header">
      <h4>{{ $tI('Left panel Title') }}</h4>
      <p class="description" v-show="$store.state.appConfig.windowWidth < 769">{{ $tI_G('Left panel Subtitle') }}</p>
    </div>

    <div class="sidebar-body">
      <div class="sidebar-menu">
        <ul>
          <li class="sidebar-item">
            <div @click="$router.push({ name: 'periodical' })" class="sidebar-link" @mouseover="hoverMenuCode = 1" @mouseout="hoverMenuCode = null"
              v-click-track="'Iframe.ancientDnaAncientOriginsBreakdownClickFromLeftPanel'">
              <div class="icon" style="margin-left: -2.5px;"><AncientOriginBreakDownIcon :is-hovered="hoverMenuCode === 1"/></div>
              <span>{{ $tI('Ancient Origins Breakdown') }}</span>
              <div class="menu-icon">
                <MenuRowIcon :is-hovered="hoverMenuCode === 1"/>
              </div>
            </div>
          </li>
          <li class="sidebar-item">
            <div @click="$router.push({ name: 'hg-farmer' })" class="sidebar-link"  @mouseover="hoverMenuCode = 2" @mouseout="hoverMenuCode = null"
              v-click-track="'Iframe.ancientDnaHunterGathererAndFarmerClickFromLeftPanel'">
              <div class="icon"><HGAndFarmerIcon  :is-hovered="hoverMenuCode === 2"/></div>
              <span>{{ $tI('Hunter Gatherer and Farmer Breakdown') }}</span>
              <div class="menu-icon">
                <MenuRowIcon :is-hovered="hoverMenuCode === 2"/>
              </div>
            </div>
          </li>
          
          <li class="sidebar-item">
            <div @click="$router.push({ name: 'closest-populations' })" class="sidebar-link"  @mouseover="hoverMenuCode = 3" @mouseout="hoverMenuCode = null"
              v-click-track="'Iframe.ancientDnaClosestPopulationsClickFromLeftPanel'">
              <div class="icon"><ClosestPopulationIcon  :is-hovered="hoverMenuCode === 3"/></div>
              <span>{{ $tI('Closest Populations') }}</span>
              <div class="menu-icon">
                <MenuRowIcon :is-hovered="hoverMenuCode === 3"/>
              </div>
            </div>
          </li>

          <li class="sidebar-item">
            <div @click="$router.push({ name: 'notable-individuals' })" class="sidebar-link"  @mouseover="hoverMenuCode = 7" @mouseout="hoverMenuCode = null"
              v-click-track="'Iframe.ancientDnaNotableConnectionsClickFromLeftPanel'">
              <div class="icon"><NotableIndividualIcon  :is-hovered="hoverMenuCode === 7"/></div>
              <span>{{ $tI('Notable Individuals') }}</span>
              <span class="new-badge" v-show="$store.state.kit.new_badge_menus.includes('Notable Individuals')">{{ $tI('New') }}</span>
              <div class="menu-icon">
                <MenuRowIcon :is-hovered="hoverMenuCode === 7"/>
              </div>
            </div>
          </li>

        </ul>
      </div>

      <div class="advanced-report">
        <h5>{{ $tI('Advanced reports') }}</h5>
      </div>
      <div class="sidebar-menu">
        <ul>
          <li class="sidebar-item">
            <div @click="$router.push({ name: 'genetic-similarities' })" class="sidebar-link" @mouseover="hoverMenuCode = 4" @mouseout="hoverMenuCode = null"
              v-click-track="'Iframe.ancientDnaGeneticSimilaritiesClickFromLeftPanel'">
              <div class="icon"><GeneticSimilaritiesIcon  :is-hovered="hoverMenuCode === 4"/></div>
              <span>{{ $tI('Genetic Similarities Breakdown') }}</span>
              <div class="menu-icon">
                <MenuRowIcon :is-hovered="hoverMenuCode === 4"/>
              </div>
            </div>
          </li>
          <li class="sidebar-item">
            <div @click="$router.push({ name: 'pca-plot' })" class="sidebar-link" @mouseover="hoverMenuCode = 5" @mouseout="hoverMenuCode = null"
              v-click-track="'Iframe.ancientDnaGeneticDistanceMapsClickFromLeftPanel'">
              <div class="icon"><PcaPlotIcon  :is-hovered="hoverMenuCode === 5"/></div>
              <span>{{ $tI('Genetic Distance Maps Title') }}</span>
              <div class="menu-icon">
                <MenuRowIcon :is-hovered="hoverMenuCode === 5"/>
              </div>
            </div>
          </li>
          <li class="sidebar-item">
            <div @click="$router.push({ name: 'sample-database' })" class="sidebar-link" @mouseover="hoverMenuCode = 6" @mouseout="hoverMenuCode = null"
              v-click-track="'Iframe.ancientDnaSampleDatabaseClickFromLeftPanel'">
              <div class="icon"><SampleDatabase  :is-hovered="hoverMenuCode === 6"/></div>
              <span>{{ $tI('Sample Database') }}</span>
              <div class="menu-icon">
                <MenuRowIcon :is-hovered="hoverMenuCode === 6"/>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <PoweredBy />
  </div>
</template>

<script>
import MenuRowIcon from '../icons/MenuRightIcon.vue';
import PoweredBy from '../ui/PoweredBy.vue';

import AncientOriginBreakDownIcon from './icons/AncientOriginBreakDownIcon.vue';
import HGAndFarmerIcon from './icons/HGAndFarmerIcon.vue';
import ClosestPopulationIcon from './icons/ClosestPopulationIcon.vue';
import NotableIndividualIcon from './icons/NotableIndividualIcon.vue';
import GeneticSimilaritiesIcon from './icons/GeneticSimilaritiesIcon.vue';
import PcaPlotIcon from './icons/PcaPlotIcon.vue';
import SampleDatabase from './icons/SampleDatabase.vue';

export default {
  name: 'AppSidebar',
  components: {
    MenuRowIcon,
    PoweredBy,
    AncientOriginBreakDownIcon,
    HGAndFarmerIcon,
    ClosestPopulationIcon,
    NotableIndividualIcon,
    GeneticSimilaritiesIcon,
    PcaPlotIcon,
    SampleDatabase,
  },
  data() {
    return {
      hoverMenuCode: null,
    };
  },
};
</script>    

<style lang="scss" scoped>
.sidebar {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 40%;
  background-color: var(--bg-body-color);

  .sidebar-header {
    padding: 28px;
    background-color: var(--white-100);
  }

  .sidebar-body {
    padding: 25px;
    .sidebar-menu {
      border-radius: 1rem;
      background-color: var(--white-100);
      ul {
        list-style-type: none;
        padding: 0;

        .sidebar-item {
          padding: 1rem;
          border-bottom: 1.5px solid var(--bg-body-color);
          .sidebar-link {
            cursor: pointer;
            text-decoration: none;
            display: flex;
            align-items: center;
            color: var(--black-100);
            &:hover {
              color: var(--mh-btn-color) !important;
            }
          }
          .icon {
            margin-top: -2px;
            width: 28px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          span {
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0.3px;
            line-height: 24px;
            margin-left: 10px;
          }

          .new-badge {
            background-color: #318648;
            color: #fff;
            font-size: 11px;
            font-weight: 600;
            line-height: 1;
            padding: 5px 7px;
            border-radius: 5px;
            margin-left: 8px;
            white-space: nowrap;
          }

          .menu-icon {
            margin-left: auto;
          }
        }
        li {
          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }

  .advanced-report {
    padding: 0 10px;
    margin-top: 30px;
    h5 {
      font-size: 1rem;
      font-weight: 500;
    }
  }

  @media screen and (max-width: 769px) {
    width: 100% !important;
  }
}
</style>
